import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/workspace/frameworkassure/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["CTASection"] */ "/workspace/frameworkassure/src/components/landing/CTASection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeaturesSection"] */ "/workspace/frameworkassure/src/components/landing/FeaturesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FrameworkSection"] */ "/workspace/frameworkassure/src/components/landing/FrameworkSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroSection"] */ "/workspace/frameworkassure/src/components/landing/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HowItWorksSection"] */ "/workspace/frameworkassure/src/components/landing/HowItWorksSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navigation"] */ "/workspace/frameworkassure/src/components/landing/Navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProblemSection"] */ "/workspace/frameworkassure/src/components/landing/ProblemSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SolutionSection"] */ "/workspace/frameworkassure/src/components/landing/SolutionSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TestimonialsSection"] */ "/workspace/frameworkassure/src/components/landing/TestimonialsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrustBar"] */ "/workspace/frameworkassure/src/components/landing/TrustBar.tsx");
